import {combineReducers, Reducer} from 'redux'
import {AliasState} from '@models/alias'
import {AliasesActionTypes} from '@actions/alias';


// Type-safe initialState!
export const initialState: AliasState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case AliasesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, alias) => {
                    obj[alias.id] = {
                        ...alias,
                        is_fetched: false,
                        ...(state[alias.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case AliasesActionTypes.CREATE_SUCCESS: {
            const alias = action.payload;
            return {
                ...state,
                [alias.id]: alias
            };
        }

        case AliasesActionTypes.UPDATE_SUCCESS: {
            const alias = action.payload;
            return {
                ...state,
                [alias.id]: {
                    ...state[alias.id],
                    ...alias
                }
            };
        }

        case AliasesActionTypes.FETCH_ITEM_SUCCESS: {
            const alias = action.payload;
            return {
                ...state,
                [alias.aliasData.id]: {
                    ...state[alias.aliasData.id],
                    ...alias.aliasData,
                    is_fetched: true,
                    reference: alias.referenceData
                },
            };
        }


        case AliasesActionTypes.UPDATE_PROPERTY_ITEM_SUCCESS: {
            const alias = action.payload;
            return {
                ...state,
                [alias.id]: {
                    ...state[alias.id],
                    ...alias,
                    is_fetched: true
                },
            };
        }

        case AliasesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.params.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});

        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case AliasesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case AliasesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.params.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case AliasesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case AliasesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case AliasesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case AliasesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case AliasesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case AliasesActionTypes.FETCH_SUCCESS:
        case AliasesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<AliasState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as aliasReducer}


//Selectors
export const getAliasesList = aliases => aliases.allIds.map(id => aliases.byId[id]);

export const getAliasById = (aliases, id) => aliases.byId[id];